<template>
    <div class="wrapper">
      <p class="title text-center">Two step-authentication</p>
      <div class="content">
        <p class="text-title">You can add an extra layer of security to your account by using a one-time code sent to your email address or mobile phone via SMS.</p>
        <div class="custom-radio-switch mt-16">
            <p class="label">Two step-authentication</p>
            <b-form-checkbox class="switch-gray custom-switch-input" switch size="lg" v-model="enableTwoStepAuth" />
        </div>
      </div>
      <!-- action btns  -->
      <hr class="h-line" />
      <div class="action-btns">
        <button class="submit-btn btn btn-primary d-flex align-items-center justify-content-center" size="md" @click="onSubmit" :disabled="isSubmitted || enableTwoStepAuth == otpRequired" >
          <i v-if="isSubmitted" class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded" ></i>
          <span>Apply</span>
        </button>
        <button @click="$bvModal.hide('twoStepAuthenticationModal')" class="btn btn-outline-danger"> Cancel </button>
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters } from "vuex";
  export default {
    data() {
      return {
        isSubmitted: false,
        enableTwoStepAuth : false,
        otpRequired : false,
      };
    },
    computed: {
      ...mapGetters("user", [ "getModalState", "getUserData"]),
      ...mapGetters("modal", ["getModalInfo"]),
    },
    methods: {
        ...mapActions("user", ["resetState"]),
        ...mapActions("authfack", ["fetchUserOtpAuthStatus", "sendOtpAuthCode", "updateUserOtpAuthStatus"]),
        ...mapActions("entities", [ "fetchUserEntities" ]),
        onSubmit() {
          this.isSubmitted = true;
          if(!this.otpRequired && this.enableTwoStepAuth){
            this.sendOtpAuthCode({'action' : 'enable_otp'}).then((res) => {
              console.log('res', res);
              this.$bvModal.hide('twoStepAuthenticationModal');
              this.$bvModal.show('verifyOtpCodeModal');
            });
          }else if(this.otpRequired && !this.enableTwoStepAuth){
            this.updateUserOtpAuthStatus({ 'otp_enabled' : false }).then((res)=>{
              console.log('res', res);
              this.fetchUserEntities();
              this.$bvModal.hide('twoStepAuthenticationModal');
            })
          }
        },
    },
    beforeMount() {
      this.resetState();
      this.fetchUserOtpAuthStatus().then((res) => {
        // console.log('res', res);
        this.enableTwoStepAuth = res.data;
        this.otpRequired = res.data;
      });
    },
  };
  </script>
  
  <style lang="scss" scoped>

    .wrapper {
        .text-title {
        font-size: 16px;
        margin-bottom: 24px;
        text-align: center;
        color: #4A4A4A;
        font-weight: 400;
        }
        .err-wrapper {
        padding-left: 53px;
        margin-top: 2px;
        }
        .h-line{
            margin-top: 40px !important;
            margin-bottom: 24px !important;
        }

        .action-btns {
            .submit-btn {
                margin-right: 32px;
            }
        }
    }

  p.text-title {
    height: 59px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
  }

</style>